import { getProviderData } from "../../../actions";
import { ShowAlert } from "../../../common/alert";
import { callMobileNumber, isMobile, isValidEmail } from "../../../helper/CommonFuncs";
import { socketActions, socketSubActions } from "../../../helper/Websocket";
import { saveusercredentials } from "../../../redux/actions/auth.action";
import { store } from "../../../redux/store";
import messagesData from "../component/shared/ErrorSuccessMessages.json";
import { clearSiteDataOnStuckOnLoader } from "../../../Apimanager/Networking";
import {
   isUserFromMarketing,
   setPaymentStatus,
   setReferralCode,
   setSsoLoginToken,
   toggleNorthwellError,
} from "../../../redux/actions/globals.action";
import {
   handleSAMLSignIn,
   handleWheelerSignIn,
   signInWithCustomTokenCustom,
   resetPasswordGlobal as resetAuthPasswordFirebase,
} from "../../../actions/firebase";
import { establishSession as establishCognitoSession, resetPassword as resetAuthPasswordCognito } from "../../../auth/cognitoAuth";
import { isCognitoAuth } from "../../../auth/region";
import {
   registerProvider as registerProviderFirebase,
   checkLogin as checkLoginFirebase,
   verifyOTP as verifyOTPFirebase,
   verifyPassword as verifyPasswordFirebase,
   authenticateProvider as authenticateProviderFirebase,
   resendOTPVerify as resendOTPVerifyFirebase,
   registerProviderWithGoogle,
} from "../../../api/onboarding";
import {
   registerProvider as registerProviderCognito,
   checkLogin as checkLoginCognito,
   verifyOTP as verifyOTPCognito,
   verifyPassword as verifyPasswordCognito,
   authenticateProvider as authenticateProviderCognito,
   resendOTPVerify as resendOTPVerifyCognito,
} from "../../../api/cognitoOnboarding";
import { isLoadedOnWebView, openApp, openAppEpic, redirectSamlLogin } from "./helpers";

const genericErrorMessage = "We couldn't complete your request. Please verify your information and try again, or contact support at support@playbackhealth.com."

export const callService = (
   step,
   email,
   password,
   key,
   otp,
   setKey = () => { },
   unsetLoader = () => { },
   setLoader = () => { },
   setStep = () => { },
   isFreemiumProvider = false,
   setIsfreemiumProvider = () => { },
   history,
   setIsMfa = () => { },
   setOpenEpicLaunch = () => { },
   fullName = "",
   handleStepChange,
   setShowPopup
) => {
   if (step === 0) {
      if (email?.length === 0) {
         ShowAlert(messagesData.messages[0]?.enterEmail, "error");
         return;
      }
      if (isValidEmail(email) === false) {
         ShowAlert(messagesData.messages[0]?.validEmail, "error");
         return;
      }
      const pathname = window.location.pathname;
      const isSignup = pathname.includes("sign-up");
      if (fullName && typeof fullName === "string" && fullName?.trim()?.split(" ")?.length < 2 && isSignup) {
         ShowAlert(messagesData.messages[1]?.enterName, "error");
         return;
      }
      setLoader();
      loginWithEmail(
         email,
         setKey,
         unsetLoader,
         setStep,
         setIsfreemiumProvider,
         history,
         setOpenEpicLaunch,
         fullName,
         handleStepChange,
         setShowPopup,
         setIsMfa
      );
   } else if (step === 1) {
      if (password?.length === 0 || password?.length < 6) {
         ShowAlert(messagesData.messages[0]?.enterPassword, "error");
         return;
      }
      setLoader();
      if (isFreemiumProvider === null) {
         verifyPasswordOldProviders(email, password, unsetLoader, setStep, setKey);
      } else {
         verifyProviderPassword(password, key, unsetLoader, setStep, setKey, setIsMfa, handleStepChange);
      }
   } else if (step === 2) {
      if (otp.length === 0 || otp.length < 6) {
         ShowAlert(messagesData.messages[0]?.missingOtp, "error");
         return;
      }
      setLoader();
      if (isFreemiumProvider === null) {
         verifyProviderOTPOld(otp, key, unsetLoader, setStep, setKey, history);
      } else {
         verifyOtp(otp, key, unsetLoader, setStep, setKey, history, setLoader);
      }
   }
};

export const differentLogin = ({ response, unsetLoader, history, callback = () => { } }) => {
   if (response?.loginSystem === "northwell") {
      if (isLoadedOnWebView()) {
         redirectSamlLogin();
         return;
      }
      handleSAMLSignIn(
         (res) => {
            const results = JSON.parse(JSON.stringify(res));
            if (results?.user) {
               getNorthwellCustomToken(results?.user?.stsTokenManager?.accessToken, () => {
                  unsetLoader();
               });
            } else {
               unsetLoader();
            }
         },
         () => {
            unsetLoader();
         }
      );
   } else if (response?.loginSystem === "nextgen") {
      const providerId = response?.providerId;
      if (providerId && providerId !== "null") {
         if (isLoadedOnWebView()) {
            redirectSamlLogin(providerId);
            return;
         }
         handleWheelerSignIn(
            (res) => {
               const results = JSON.parse(JSON.stringify(res));
               if (results?.user) {
                  const CustomToken = results?.user?.stsTokenManager?.accessToken;
                  WheelerMultipleAccountLogin(CustomToken, history, () => {
                     unsetLoader();
                  });
               } else {
                  unsetLoader();
               }
            },
            () => {
               unsetLoader();
            },
            providerId
         );
         return;
      }
   } else if (response?.loginSystem === "epic") {
      localStorage.setItem("epicLoginKey", response?.key);
      window.location.replace(response?.authenticationURL);
   } else {
      callback();
   }
};

export const loginWithEmail = (
   email,
   setKey = () => { },
   unsetLoader = () => { },
   setStep,
   setIsfreemiumProvider,
   history,
   setOpenEpicLaunch = () => { },
   fullName,
   handleStepChange,
   setShowPopup,
   setIsMfa = () => { }
) => {
   const pathname = window.location.pathname;
   const isSignup = pathname.includes("sign-up");
   const query = window.location.search;
   const match = query.match(/[?&]referral=([^&]+)/);
   const referral = match ? match[1] : null;
   if (isSignup) {
      if (window.location.search.includes("payment=true")) {
         store.dispatch(isUserFromMarketing());
         if (window.location.search.includes("monthly=true")) {
            store.dispatch(setPaymentStatus());
         }
      }

      const registerProvider = isCognitoAuth() ? registerProviderCognito : registerProviderFirebase;
      registerProvider({
         email: email,
         name: fullName,
         referralCode: referral,
         signUpMethod: "email",
      })
         .then((response) => {
            differentLogin({
               response,
               unsetLoader,
               history,
               callback: () => {
                  loginProvider(response, history, unsetLoader, "/trial");
               },
            });
         })
         .catch((error) => {
            unsetLoader();
            if (email?.toLowerCase()?.includes("@northwell.edu")) {
               unsetLoader();
            }
            if (
               error?.status === 409 &&
               error?.data?.message?.toLowerCase() ===
               "the email address is invalid. please try again or contact support at support@playbackhealth.com."
            ) {
               setShowPopup(true);
            }
         });
      return;
   }

   // First check if user exists
   const checkLogin = isCognitoAuth() ? checkLoginCognito : checkLoginFirebase;
   checkLogin({ email, signInMethod: "email", unsetLoader })
      .then((response) => {
         setIsMfa(response.mfa);
         if (!response) {
            unsetLoader();
            return;
         }
         differentLogin({
            response,
            unsetLoader,
            history,
            callback: () => {
               if (response.userId) {
                  unsetLoader();
                  setKey(response.userId);
                  if (response.isFreemiumProvider) {
                     setIsfreemiumProvider();
                  }
                  if (response.hasPassword === false) {
                     handleStepChange(2); // Skip password screen, go to OTP
                  } else {
                     handleStepChange(1); // Show password screen
                  }
               }
            },
         });
      })
      .catch((error) => {
         unsetLoader();
         // handleStepChange(1)
         // if (
         //    error?.status === 404 &&
         //    error?.data?.message?.toLowerCase() ===
         //    "the email address is invalid. please try again or contact support at support@playbackhealth.com."
         // ) {
         //    setShowPopup(true);
         //    return;
         // }
         // else {
         //    ShowAlert(error?.data?.message || "Login failed", "error");
         // }

      });
   return;
};

export const verifyProviderPassword = async (
   password,
   key,
   unsetLoader,
   setStep,
   setKey,
   setIsMfa,
   handleStepChange
) => {
   try {
      const response = await verifyPassword(password, key, unsetLoader, setStep, setKey, setIsMfa, handleStepChange);
      unsetLoader();
      if (response) {
         if (response.isFreemiumProvider) {
            setKey(response.userId);
            setIsMfa(response.mfa);
            handleStepChange(2);
         }
      }
   } catch (error) {
      unsetLoader();
      ShowAlert(error.message || "Password verification failed", "error");
   }
};

export const verifyPasswordOldProviders = (
   email,
   password,
   unsetLoader = () => { },
   setStep = () => { },
   setKey,
   resendOtp = false,
   success = () => { }
) => {
   let str = {
      action: socketActions.auth,
      subAction: socketSubActions.validateProvider,
      emailId: email,
      password: password,
   };
   window.socket.send(str, (resultStatus) => {
      unsetLoader();
      if (resultStatus.settings?.status === 1) {
         if (resendOtp) {
            ShowAlert(messagesData.messages[0]?.resendOtp);
            success();
         }
         setStep();
         setKey(resultStatus?.data?.userId);
      } else {
         ShowAlert(genericErrorMessage || resultStatus.settings?.message, "error");
      }
   });
};

export const verifyOtp = (otp, key, unsetLoader = () => { }, setStep, setKey, history, setLoader = () => { }) => {
   setLoader();
   const verifyOTP = isCognitoAuth() ? verifyOTPCognito : verifyOTPFirebase;
   verifyOTP({ key, otp })
      .then((result) => {
         if (result && isCognitoAuth()) {
            if (isLoadedOnWebView()) {
               const resultToken = result;
               openAppEpic(resultToken);
               return;
            }
            loginProvider(result, history, unsetLoader);
            return
         }
         if (result.customToken) {
            if (isLoadedOnWebView()) {
               openAppEpic(result.customToken);
               return;
            }
            loginProvider(result, history, unsetLoader);
         } else {
            unsetLoader();
            ShowAlert(result.message || "OTP verification failed", "error");
         }
      })
      .catch((error) => {
         unsetLoader();
         ShowAlert(error.message || "OTP verification failed", "error");
      });
};

export const verifyProviderOTPOld = (otp, key, unsetLoader = () => { }, setStep, setKey, history) => {
   let str2 = {
      action: socketActions.auth,
      subAction: socketSubActions.verifyProviderOTP,
      enteredOtp: otp,
      userId: key,
   };

   window.socket.send(str2, (resultStatus) => {
      if (resultStatus.settings?.status === 1) {
         loginProvider(resultStatus?.data, history, unsetLoader);
      } else {
         unsetLoader();
         ShowAlert(genericErrorMessage || resultStatus.settings?.message, "error");
      }
   });
};

export const loginProvider = (success, history, unsetLoader, path = "/notes") => {
   const dispatch = store.dispatch;

   const completeLogin = () => {
      if (success.userData) {
         dispatch(saveusercredentials({ user: success.userData }));
      }
      if (path === "/trial") {
         history.push("/trial");
      } else {
         redirectUser(path);
      }
      getProviderData(null, true);
   };

   if (isCognitoAuth()) {
      establishCognitoSession(success)
         .then(completeLogin)
         .catch((error) => {
            console.log(error);
            unsetLoader();
         });
      return;
   }

   signInWithCustomTokenCustom(
      success.customToken,
      () => {
         completeLogin();
      },
      (error) => {
         console.log(error);
         unsetLoader();
      }
   );
};
export const SignUpProvider = (success, history, pushHistory = true) => {
   clearSiteDataOnStuckOnLoader((callback = () => { }) => {
      const dispatch = store.dispatch;

      const completeSignup = () => {
         callback();
         if (success.userData) {
            dispatch(saveusercredentials({ user: success.userData }));
         }
         if (pushHistory) {
            redirectUser("/notes");
         }
      };

      if (isCognitoAuth()) {
         establishCognitoSession(success)
            .then(completeSignup)
            .catch((error) => {
               console.log(error);
            });
         return;
      }

      signInWithCustomTokenCustom(
         success.customToken,
         completeSignup,
         (error) => {
            console.log(error);
         }
      );
   });
};
export const VerifyProvider = (success, callback = () => { }) => {
   if (isCognitoAuth()) {
      establishCognitoSession(success)
         .then(callback)
         .catch((error) => {
            console.log(error);
         });
      return;
   }

   signInWithCustomTokenCustom(
      success.customToken,
      () => {
         callback();
      },
      (error) => {
         console.log(error);
      }
   );
};

export const callUnderlineServiceApi = (
   step,
   setLoader,
   unsetLoader,
   key,
   email,
   password,
   setKey,
   isFreemiumProvider
) => {
   if (step === 0) {
      callMobileNumber("+19179707517");
   } else if (step === 1) {
      resetPassword(email, unsetLoader);
   } else if (step === 2) {
      if (isFreemiumProvider) {
         resendOTPFreemiumProvider(key, unsetLoader, setKey);
      } else {
         verifyPasswordOldProviders(email, password, unsetLoader, () => { }, setKey, true);
      }
   }
};

export const resendCodeNew = (
   setLoader,
   unsetLoader,
   key,
   email,
   password,
   setKey,
   isFreemiumProvider,
   resendOtp = () => { }
) => {
   setLoader();
   if (isFreemiumProvider) {
      resendOTPFreemiumProvider(key, unsetLoader, setKey, resendOtp);
   } else {
      verifyPasswordOldProviders(email, password, unsetLoader, () => { }, setKey, true, resendOtp);
   }
};

export const resetPassword = (emailAddress, unsetLoader) => {
   const resetAuthPassword = isCognitoAuth() ? resetAuthPasswordCognito : resetAuthPasswordFirebase;
   resetAuthPassword(
      emailAddress,
      () => {
         unsetLoader();
         ShowAlert(messagesData.messages[0]?.emailSent, "success");
      },
      () => {
         unsetLoader();
         ShowAlert("Error sending password recovery link !", "error");
      }
   );
};

// export const resendOTPFreemiumProvider = (key, unsetLoader = () => {}, setKey = () => {}, success = () => {}) => {
//    let str = {
//       action: socketActions.onboarding,
//       subAction: socketSubActions.resendOTPFreemium,
//       key: key,
//    };
//    window.socket.send(str, (resultStatus) => {
//       unsetLoader();
//       if (resultStatus.settings?.status === 1) {
//          setKey(resultStatus?.data?.userId);
//          ShowAlert(messagesData.messages[0]?.resendOtp);
//          success();
//       } else {
//          ShowAlert(resultStatus.settings?.message, "error");
//       }
//    });
// };

export const resendOTPFreemiumProvider = async (key, unsetLoader = () => { }, setKey = () => { }, success = () => { }) => {
   try {
      const resendOTPVerify = isCognitoAuth() ? resendOTPVerifyCognito : resendOTPVerifyFirebase;
      const result = await resendOTPVerify({ key });
      unsetLoader();
      setKey(result?.userId);
      ShowAlert(messagesData.messages[0]?.resendOtp);
      success();
   } catch (error) {
      unsetLoader();
      ShowAlert(error?.data?.message || "Failed to resend OTP", "error");
   }
};

export const MultipleAccountLogin = (customToken, history, callback = () => { }, isNorthwellProvider = false) => {
   if (isNorthwellProvider) {
      getNorthwellCustomToken(customToken, callback, history);
      return;
   }
   let obj = {
      action: socketActions.onboarding,
      subAction: socketSubActions.authenticateProvider,
      token: customToken,
   };
   window.socket.send(obj, (resultStatus) => {
      localStorage.removeItem("provider");
      if (resultStatus.settings?.status === 1) {
         if (!resultStatus?.data?.isUserExist) {
            store.dispatch(setSsoLoginToken(customToken));
            if (window.location.search.includes("referral=")) {
               const query = window.location.search;
               const match = query.match(/[?&]referral=([^&]+)/);
               const referral = match ? match[1] : null;
               store.dispatch(setReferralCode(referral));
            }
            if (window.location.search.includes("payment=true")) {
               store.dispatch(isUserFromMarketing());
               if (window.location.search.includes("monthly=true")) {
                  store.dispatch(setPaymentStatus());
               }
            }
            history.push("/trial");
            return;
         }
         const checkOld = resultStatus?.data?.isFreemiumProvider === false && resultStatus?.data?.isUserExist === true;
         if (checkOld) {
            const northwell = resultStatus?.data?.loginSystem === "northwell";
            if (northwell) {
               getNorthwellCustomToken(customToken, callback, history);
            } else {
               callback(resultStatus?.data?.email);
            }
         } else {
            const message = resultStatus?.data;
            SignUpProvider(message, history);
         }
      } else {
         ShowAlert(resultStatus?.settings?.message, "error");
         callback();
      }
   });
};

export const MultipleSSOAccountLogin = async (customToken, history, callback = () => { }, errorNew = () => { }) => {
   try {
      const authenticateProvider = isCognitoAuth()
         ? authenticateProviderCognito
         : authenticateProviderFirebase;
      const resultStatus = await authenticateProvider({
         token: customToken,
      });
      if (isLoadedOnWebView()) {
         openAppEpic(resultStatus.customToken);
         return;
      }
      localStorage.removeItem("provider");
      SignUpProvider(resultStatus, history);
   } catch (error) {
      if (
         error?.status === 404 &&
         error?.data?.message?.toLowerCase() ===
         "the email address is invalid. please try again or contact support at support@playbackhealth.com."
      ) {
         if (isLoadedOnWebView()) {
            registerProviderWithGoogle({
               token: customToken
            })
               .then((res) => {
                  loginProvider(
                     res,
                     history,
                     () => {

                     },
                     "/trial"
                  );
                  // openAppEpic(res.customToken);

               })
            return
         }
         errorNew();
      }
      callback();
   }
};

export const WheelerMultipleAccountLogin = (customToken, history, callback = () => { }) => {
   let obj = {
      action: socketActions.onboarding,
      subAction: socketSubActions.exchangeTokenEhrIntegration,
      token: customToken,
   };
   window.socket.send(obj, (resultStatus) => {
      if (resultStatus.settings?.status === 1) {
         if (isLoadedOnWebView()) {
            openAppEpic(resultStatus.customToken);
            return;
         }
         SignUpProvider(resultStatus.data, history, true);
      } else {
         ShowAlert(resultStatus?.settings?.message, "error");
         callback();
      }
   });
};

export const getNorthwellCustomToken = (customToken, callback = () => { }, history) => {
   const requestData = {
      action: socketActions.auth,
      subAction: socketSubActions.customToken,
      providerToken: customToken,
   };

   window.socket.send(requestData, (success) => {
      if (success.settings?.status === 1) {
         const message = success?.data;
         SignUpProvider(message, history, true);
      } else {
         callback();
         localStorage.removeItem("redirect");
         localStorage.removeItem("loginSystem");
         localStorage.removeItem("provEmail");
         localStorage.removeItem("providerKey");
         store.dispatch(toggleNorthwellError());
      }
   });
   // }
};

export const VerifyNorthwellAccount = (customToken, callback = () => { }) => {
   let obj = {
      action: socketActions.onboarding,
      subAction: socketSubActions.createNorthwellCustomToken,
      providerToken: customToken,
      key: localStorage.getItem("northwellKey"),
   };
   window.socket.send(obj, (resultStatus) => {
      if (resultStatus.settings?.status === 1) {
         loginNorthwellProvider(resultStatus?.data);
         callback();
         ShowAlert("Account verified successfully");
      } else {
         ShowAlert(resultStatus.settings?.message, "error");
         callback();
      }
   });
};

export const loginNorthwellProvider = (success) => {
   const dispatch = store.dispatch;

   const completeLogin = () => {
      if (success.user) {
         dispatch(saveusercredentials({ user: success.user }));
      }
      getProviderData(null, true);
   };

   if (isCognitoAuth()) {
      establishCognitoSession({
         accessToken: success.accessToken,
         refreshToken: success.refreshToken,
         idToken: success.idToken,
         userData: success.user,
      })
         .then(completeLogin)
         .catch((error) => {
            console.log(error);
         });
      return;
   }

   signInWithCustomTokenCustom(
      success.customToken,
      completeLogin,
      (error) => {
         console.log(error);
      }
   );
};

export const SignUpProviderSSO = (success) => {
   const customToken = success.customToken;
   const userData = success.userData;
   const dispatch = store.dispatch;

   signInWithCustomTokenCustom(
      customToken,
      () => {
         let userDatas = { user: userData };
         dispatch(saveusercredentials(userDatas));
         getProviderData(null, true);
      },
      (error) => {
         console.log(error);
      }
   );
};

export const verifyPassword = async (password, key, unsetLoader, setStep, setKey, setIsMfa, handleStepChange) => {
   try {
      const verifyPasswordApi = isCognitoAuth() ? verifyPasswordCognito : verifyPasswordFirebase;
      const response = await verifyPasswordApi({
         key: key,
         password: password,
         authMethod: "password",
      });
      unsetLoader();
      if (response) {
         if (response.isFreemiumProvider) {
            setKey(response.userId);
            setIsMfa(response.mfa);
            handleStepChange(2);
         }
      }
   } catch (error) {
      unsetLoader();
      ShowAlert(error.message || "Password verification failed", "error");
   }
};
export const redirectUser = (path) => {
   let actualPath = path;
   openApp();
   if (localStorage.getItem("isLoadedOnWebView") !== "true") {
      const clear = setTimeout(() => {
         window.location.href = actualPath;
         clearInterval(clear);
      }, 2000);
   }
};
